import { LISTING_TYPES } from "../Listing.constants";

// TODO: Remove this function once checkout is done for all listings
/**
 * This is a temporary util that checks if the current listing type has checkout page for it.
 * In future, this will be removed once checkout page is made for all listing types
 * @param param0 listingType - listing type
 * @returns boolean check if checkout page exists
 */
export const checkIsCheckoutEnabledListing = ({
    listingType,
}: {
    listingType: number;
}) => {
    if (
        [
            LISTING_TYPES.NO_SCHEDULE,
            LISTING_TYPES.WEBINAR,
            LISTING_TYPES.RECORDED_CONTENT,
            LISTING_TYPES.BRANDED_COMMUNITY,
            LISTING_TYPES.WHATSAPP,
            LISTING_TYPES.WORKSHOPS,
            LISTING_TYPES.APPOINTMENTS,
            LISTING_TYPES.GROUP_CLASSES,
            LISTING_TYPES.ROLLING_CLASSES,
            LISTING_TYPES.ONE_ON_ONE_CLASSES,
            LISTING_TYPES.TELEGRAM,
            LISTING_TYPES.MERCHANDISE,
        ].includes(listingType)
    ) {
        return true;
    }
    return false;
};
